import React from 'react';

type SearchIconProps = React.SVGAttributes<SVGElement> & {
  className?: string;
};

export const SearchIcon = ({ className, ...props }: SearchIconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    className={className}
    {...props}
  >
    <g clipPath='url(#clip0_5917_74484)'>
      <path
        d='M1.63935 9.31989C1.92059 9.98166 2.32943 10.5816 2.84252 11.0853C3.35561 11.5891 3.96291 11.9869 4.62973 12.256C5.29655 12.525 6.00984 12.6601 6.72887 12.6536C7.4479 12.647 8.15859 12.4988 8.82037 12.2176C9.48215 11.9363 10.0821 11.5275 10.5858 11.0144C11.0896 10.5013 11.4874 9.89401 11.7564 9.22719C12.0255 8.56037 12.1606 7.84708 12.154 7.12804C12.1474 6.40901 11.9993 5.69832 11.718 5.03654C11.4368 4.37476 11.028 3.77486 10.5149 3.27109C10.0018 2.76731 9.39448 2.36953 8.72766 2.10045C8.06084 1.83138 7.34755 1.69628 6.62852 1.70287C5.90949 1.70945 5.19879 1.8576 4.53702 2.13885C3.87524 2.4201 3.27534 2.82894 2.77156 3.34203C2.26779 3.85513 1.87001 4.46242 1.60094 5.12924C1.33186 5.79606 1.19676 6.50935 1.20335 7.22838C1.20995 7.94741 1.3581 8.65811 1.63935 9.31989Z'
        stroke='#828A8F'
        strokeWidth={1.5}
      />
      <path d='M10.5503 11.0498L14.797 15.2971' stroke='#828A8F' strokeWidth={1.5} />
    </g>
    <defs>
      <clipPath id='clip0_5917_74484'>
        <rect width='16' height='16' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
);
